import React from "react";
import { Dialog, DialogContent, DialogTitle, GridLegacy } from "@mui/material";
import TranslationWrapper from "../../components/TranslationWrapper/TranslationWrapper";
import FormTextTC from "../../components/Forms/FormTextTC";
import FormV2 from "../JamezzForm/FormV2";

const endPoint = "core/roles";

function CreateNewRoleDialog(props) {
  return (
    <Dialog fullWidth={true} maxWidth={"lg"} onClose={() => props.onClose()} open={true}>
      <DialogTitle>
        <TranslationWrapper tDefault={"Create new role"} tKey={"roles.createNewRole"} />
      </DialogTitle>
      <DialogContent>
        <FormV2
          endPoint={endPoint}
          getEditLink={(row) => {
            return `./${row.id}/edit`;
          }}
          mode={"onSubmit"}
          revalidateMode={"onChange"}
        >
          <GridLegacy container spacing={1}>
            <FormTextTC name={"name"} tDefault={"Role name"} tKey={"roles.name"} />
          </GridLegacy>
        </FormV2>
      </DialogContent>
    </Dialog>
  );
}

export default CreateNewRoleDialog;
